import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import {
  Container,
  Row,
  Col,
  Image,
  OverlayTrigger,
  Tooltip,
  Spinner,
} from 'react-bootstrap';
import ClassImg from '../../../assets/images/old-letsgo.svg';
import starIcon from '../../../assets/icon/icon-my-room-star.svg';
import flagIcon from '../../../assets/icon/icon-my-room-flag.svg';
import { useAuth } from '../../auth/Auth';
import '../my_room/css/myroom.scss';
import MyBadge from '../../common/MyBadge';
import {
  MY_ROOM_ROUTE,
  PARTNER_LOGIN,
} from '../../../constants/routes.constants';
import defaultBannerImg from '../../../assets/images/bg_MyRoom.svg';
import defaultProfilePic from '../../../assets/profile/default-profile-guardian.svg';
import notVerified from '../../../assets/icon/Unverified.svg';
import PartnerHeader from '../school/PartnerHeader';
import CampHeader from '../../header/CampHeader';
import CampHeaderGuest from '../../header/CampHeaderGuest';
import { schoolViewModel } from '../school/school.view.model';
import greenTick from '../../../assets/icon/green_tick.svg';
import InfiniteScroll from 'react-infinite-scroller';
import MyRoomLeftSideBar from '../my_room/MyRoomLeftSideBar';
import MyRoomRightSideBar from '../my_room/MyRoomRightSideBar';
import TribeRoom from '../my_room/TribeRoom';
import TreehouseSelectbox from '../school/TreehouseSelectBox';
import CreatorCamp from '../camp_schedule/CreatorCamp';
import OptimizeSignup from '../onboarding/signup_popups/OptimizeSignup';
import KidCommonRoomChallengeList from './KidCommonRoomChallengeList';
import Home from '../../../assets/icon/header/Home.svg';
import HomeActive from '../../../assets/icon/header/Home_active.svg';
import Challenge from '../../../assets/icon/header/City.svg';
import ChallengeActive from '../../../assets/icon/header/City_active.svg';
import FeedGallery from '../feed/FeedGallery';
import { feedViewModel } from '../feed/feed.view.model';
import './kid-common-room.css';

const TeachersRoom = ({ treehouse }) => {
  const history = useHistory();
  const { dependent, school, partner, fetchAPI } = useAuth();
  const [width, setWidth] = useState(window.innerWidth);
  const user = school ? school : partner;
  const [challengeCount, setChallengeCount] = useState(0);
  const [creationCount, setCreationCount] = useState(0);
  const [subscriptionCount, setSubscriptionCount] = useState(0);
  const [tabFlag, setTabFlag] = useState('challenge');
  const [bgImg, setBgImg] = useState(treehouse.profile?.school?.banner_url);
  const [upcomingChallengeList, setUpcomingChallengeList] = useState([]);
  const [liveChallengeList, setLiveChallengeList] = useState([]);
  const [pastChallengeList, setPastChallengeList] = useState([]);
  const [challengeList, setChallengeList] = useState([]);
  const [tribeList, setTribeList] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [leftCollapsse, setLeftCollapsse] = useState('');
  const [rightCollapsse, setRightCollapsse] = useState('');
  const [selectedTabClass, setSelectedTabClass] = useState('selected-dark');
  const [unSelectedTabClass, setUnselectedTabClass] = useState('unselected');
  const [nameTextColor, setNameTextColor] = useState('text-dark');
  const [selectedTreehouse, setSelectedTreehouse] = useState('All');
  const [isDisabled, setIsDisabled] = useState(true);
  const [loading, setLoading] = useState(false);
  const [creationList, setCreationList] = useState([]);
  const [creationLoading, setCreationLoading] = useState(false);
  const [interestTickColor, setInterestTickColor] = useState(
    'interest-tickbtn-outline-light'
  );
  const [upcomingQuery, setUpcomingQuery] = useState({
    limit: 9,
    has_more: true,
    // availability: "upcoming",
    // teacher_id: treehouse.id
  });
  const [currentQuery, setCurrentQuery] = useState({
    limit: 9,
    has_more: true,
    availability: 'current',
    // teacher_id: treehouse.id
  });

  const [pastQuery, setPastQuery] = useState({
    limit: 9,
    has_more: true,
    availability: 'previous',
    // teacher_id: treehouse.id
  });

  const [creationQuery, setCreationQuery] = useState({
    limit: 9,
    has_more: true,
  });

  const handleChange = () => {
    const list = [];
    const query = {
      limit: 9,
      has_more: true,
    };
    const cQuery = {
      limit: 9,
      has_more: true,
    };
    if (selectedTreehouse && selectedTreehouse !== 'All') {
      cQuery.group_id = treehouse?.id;
    } else {
      cQuery.camp_id = treehouse?.camp_details?.id;
      cQuery.group_id = treehouse?.id;
    }
    setChallengeList(list);
    setUpcomingQuery(query);
    getChallenges(list, query);
    setCreationList(list);
    setCreationQuery(query);
    getCreations(list, cQuery);
  };

  useEffect(() => {
    handleChange();
  }, [tabFlag, selectedTreehouse]);

  const getChallenges = (list, query) => {
    let params = { ...query };
    if (selectedTreehouse && selectedTreehouse !== 'All') {
      params.group_id = treehouse.id;
    } else {
      params.school_id = treehouse?.camp_details?.id;
    }
    // params.availability = tabFlag;
    const API = getAPI();
    if (API) {
      if (!loading) fetch(API, params, list);
    } else {
      setLoading(false);
    }
  };

  const getInfiniteChallenges = () => {
    const upcomingChallengeList = challengeList;
    let params = { ...upcomingQuery };
    if (selectedTreehouse && selectedTreehouse !== 'All') {
      params.group_id = treehouse.id;
    } else {
      params.school_id = treehouse?.camp_details?.id;
    }
    // params.availability = tabFlag;
    const API = getAPI();
    if (API) {
      if (!loading) fetch(API, params, upcomingChallengeList);
    } else {
      setLoading(false);
    }
  };

  const fetch = async (API, params, upcomingChallengeList) => {
    setLoading(true);
    try {
      const res = await API(params, upcomingChallengeList);
      setChallengeList(res.newList);
      setUpcomingQuery(res.query);
    } catch (err) {
      console.log(err);
      if (err.statusCode === 500) {
        history.push(PARTNER_LOGIN);
      }
    }
    setLoading(false);
  };

  const getAPI = () => {
    // switch (tabFlag) {
    //   case 'upcoming':
    //     return selectedTreehouse === 'All'
    //       ? schoolViewModel.getPublicCampChallenges
    //       : schoolViewModel.getUpcomingChallenges;
    //   case 'current':
    //     return selectedTreehouse === 'All'
    //       ? schoolViewModel.getPublicCampChallenges
    //       : schoolViewModel.getLiveChallenges;
    //   case 'previous':
    //     return selectedTreehouse === 'All'
    //       ? schoolViewModel.getPublicCampChallenges
    //       : schoolViewModel.getPastChallenges;
    //   default:
    //     return null;
    // }
    if (selectedTreehouse === 'All') {
      return schoolViewModel.getPublicCampChallenges;
    } else {
      return schoolViewModel.getLiveChallenges;
    }
  };

  let myRoomImageStyle = {
    backgroundImage: bgImg ? `url(${bgImg})` : `url(${defaultBannerImg})`,
  };

  const getBadgeCount = () => {
    // let API = treehouse ? treehouseViewModel.getSchoolBadgeCount : treehouseViewModel.getPartnerBadgeCount
    let API = schoolViewModel.getBadgeCount;
    API(treehouse?.camp_details?.id)
      .then((res) => {
        setChallengeCount(res.challenge_count);
        setCreationCount(res.creation_count);
        if (res.subscription_count) {
          setSubscriptionCount(res.subscription_count);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const getTribeList = () => {
    schoolViewModel
      .getCampMasterTribes(treehouse?.camp_details?.id)
      .then((res) => {
        setTribeList(res);
        // setSelectedTreehouse([res.filter((item) => item.id === treehouse?.id)]);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    if (treehouse) {
      getBadgeCount();
    }
    if (dependent) {
      getTribeList();
    }
  }, []);

  const renderTooltip = (treehouse) => (
    <Tooltip id="button-tooltip">
      {treehouse
        ? 'This account passed KYC and is verified for the creative camp that a parent or guardian has given permission for their kid to access'
        : ''}
    </Tooltip>
  );

  const [selectedMember, setSelectedMember] = useState({});
  const handleMemberCLick = (member) => {
    if (member?.id === dependent?.id) {
      setSelectedMember({});
      history.push(MY_ROOM_ROUTE);
    } else {
      setSelectedMember(member);
    }
  };

  const fetchFunCreation = async (API, params, list) => {
    setCreationLoading(true);
    try {
      const res = await API(params, list);
      setCreationList(res.feedList);
      setCreationQuery(res.query);
    } catch (err) {
      console.log(err);
    }
    setCreationLoading(false);
  };

  const getCreations = (list, query) => {
    let params = { ...query };
    if (selectedTreehouse && selectedTreehouse !== 'All') {
      params.group_id = selectedTreehouse[0]?.id;
    }
    const API = feedViewModel.getFeed;
    if (API) {
      if (!creationLoading) fetchFunCreation(API, params, list);
    } else {
      setCreationLoading(false);
    }
  };

  const getInfiniteCreations = () => {
    getCreations(creationList, creationQuery);
  };

  const handleBinky = (creationId, binkyId, binkyCount) => {
    const newList = creationList.map((obj) => {
      return obj.id === creationId
        ? {
            ...obj,
            binky_count: binkyCount,
            binky_id: binkyId,
          }
        : obj;
    });
    setCreationList(newList);
  };

  const handleComment = (creationId, newCommentCount) => {
    const newList = creationList.map((obj) => {
      return obj.id === creationId
        ? {
            ...obj,
            comment_count: newCommentCount,
          }
        : obj;
    });
    setCreationList(newList);
  };

  return (
    <div className="myroom-main kid-common-room-container room-expansion partner_myroom_main partner-wrapper-main">
      {dependent ? (
        <div className="camp-left sticky-top">
          <CampHeader
            leftCollapsse={leftCollapsse}
            rightCollapsse={rightCollapsse}
          />
        </div>
      ) : school || partner ? (
        <PartnerHeader />
      ) : (
        <div className="camp-right-logo">
          {' '}
          <CampHeaderGuest />{' '}
        </div>
      )}
      <OptimizeSignup showModal={showModal} setShowModal={setShowModal} />
      <div className="flex-wrapper sidebar-arrows" id="myroom-theme">
        <MyRoomLeftSideBar
          width={width}
          handleMemberCLick={handleMemberCLick}
          myInterests={true}
          setLeftCollapsse={setLeftCollapsse}
          setShowModal={setShowModal}
          selectedTabClass={selectedTabClass}
          selectedMember={selectedMember}
          rightCollapsse={rightCollapsse}
          setSelectedMember={setSelectedMember}
          selectedTreehouse={selectedTreehouse}
          treehousesList={tribeList}
          treehouse={treehouse}
        />
        <div
          className={'flex-col-center ' + rightCollapsse + ' ' + leftCollapsse}
        >
          {selectedMember.id ? (
            <TribeRoom
              creator={selectedMember}
              selectedTabClass={selectedTabClass}
              unSelectedTabClass={unSelectedTabClass}
              nameTextColor={nameTextColor}
              interestTickColor={interestTickColor}
              setSelectedMember={setSelectedMember}
            />
          ) : (
            <div className="myroom-profile-info main-tab">
              <div
                className={
                  bgImg
                    ? 'myroom-info-container overlay-container container new-banner-image'
                    : 'myroom-info-container overlay-container container'
                }
                style={myRoomImageStyle}
              >
                <Container fluid="md">
                  <Row className="myroom-info-wrapper">
                    <Col md={7} lg={7} xl={7}>
                      <div className="myroom-collapse">
                        <div className="avatar-wrapper">
                          <div className="full-big-type">
                            <Row>
                              <div className="avatar-image">
                                <Image
                                  className="rounded-circle profile-image"
                                  src={
                                    treehouse.camp_details?.picture
                                      ? treehouse.camp_details?.picture
                                      : defaultProfilePic
                                  }
                                />
                              </div>
                              <div className="user-info">
                                <div className="name-favorites">
                                  <div className="user-name">
                                    {treehouse.camp_details?.school_name}
                                    <OverlayTrigger
                                      placement="top"
                                      delay={{ show: 250, hide: 400 }}
                                      overlay={renderTooltip(treehouse)}
                                    >
                                      {treehouse.camp_details?.is_verified ? (
                                        <Image
                                          className="blue_badge"
                                          src={greenTick}
                                        />
                                      ) : (
                                        <Image
                                          className="blue_badge"
                                          src={notVerified}
                                        />
                                      )}
                                    </OverlayTrigger>
                                  </div>
                                  <div className="favorites">
                                    {treehouse?.camp_details?.description}
                                  </div>
                                </div>
                              </div>
                            </Row>
                            <Row className="badge-wrapper">
                              <MyBadge
                                icon={flagIcon}
                                count={challengeCount}
                                className="first-badge"
                                title="Challenges published"
                              />
                              <MyBadge
                                icon={starIcon}
                                count={creationCount}
                                title="Creations submitted"
                              />
                            </Row>
                          </div>
                        </div>
                      </div>
                    </Col>
                    <Col md={{ span: 5 }} lg={{ span: 5 }} xl={{ span: 5 }}>
                      <div className="join-camp-wrapper">
                        <div className="filter-container">
                          <div className="filter-tag">
                            <TreehouseSelectbox
                              treehousesList={tribeList}
                              selectedTreehouse={selectedTreehouse}
                              setSelectedTreehouse={setSelectedTreehouse}
                              setIsDisabled={setIsDisabled}
                              setUpcomingChallengeList={
                                setUpcomingChallengeList
                              }
                              setPastChallengeList={setPastChallengeList}
                              setLiveChallengeList={setLiveChallengeList}
                              setUpcomingQuery={setUpcomingQuery}
                              setPastQuery={setPastQuery}
                              setCurrentQuery={setCurrentQuery}
                              isCommonRoom={true}
                              tribeId={treehouse?.id}
                            />
                          </div>
                        </div>
                        <CreatorCamp />
                      </div>
                    </Col>
                  </Row>
                </Container>
              </div>
              <Container fluid="md">
                <div className="myroom-creation-title">
                  <div
                    className={`tab tab-left pt-2 pb-2 ${
                      tabFlag === 'creation' ? 'selected' : 'unselected'
                    }`}
                    onClick={() => {
                      setTabFlag('creation');
                    }}
                  >
                    <div className="public-page-tabs">
                      <Image
                        src={tabFlag === 'creation' ? HomeActive : Home}
                        alt="challenge"
                      />
                    </div>
                  </div>
                  <div
                    className={`tab tab-left pt-2 pb-2 ${
                      tabFlag === 'challenge' ? 'selected' : 'unselected'
                    }`}
                    onClick={() => {
                      setTabFlag('challenge');
                    }}
                  >
                    <div className="public-page-tabs">
                      <Image
                        src={
                          tabFlag === 'challenge' ? ChallengeActive : Challenge
                        }
                        alt="challenge"
                      />
                    </div>
                  </div>
                  {/* <div
                    className={`tab tab-right pt-4 pb-2 ${
                      tabFlag === 'previous' ? 'selected' : 'unselected'
                    }`}
                    onClick={() => {
                      setTabFlag('previous');
                    }}
                  >
                    <div className="public-page-tabs">Past </div>
                  </div> */}
                </div>
                {tabFlag === 'challenge' && (
                  <Row className="myroom-challenge-container">
                    {challengeList.length !== 0 ? (
                      <InfiniteScroll
                        pageStart={0}
                        loadMore={getInfiniteChallenges}
                        hasMore={upcomingQuery.has_more}
                        initialLoad={false}
                        loader={
                          <Spinner
                            key={0}
                            className="myroom-spinner"
                            animation="border"
                            variant="info"
                          />
                        }
                        threshold={150}
                      >
                        <KidCommonRoomChallengeList
                          challengeList={challengeList}
                        />
                      </InfiniteScroll>
                    ) : (
                      <div className="myroom-creation-container">
                        <div className="choose-class">
                          <Image
                            className="rounded-circle profile-image"
                            src={ClassImg}
                          />
                          There are no upcoming challenges, yet.
                        </div>
                      </div>
                    )}
                  </Row>
                )}
                {tabFlag === 'creation' && (
                  <div className={`myroom-creation-container`}>
                    <InfiniteScroll
                      pageStart={0}
                      loadMore={getInfiniteCreations}
                      hasMore={creationQuery.has_more}
                      initialLoad={false}
                      loader={
                        <Spinner
                          key={0}
                          className="myroom-spinner"
                          animation="border"
                          variant="info"
                        />
                      }
                      threshold={150}
                    >
                      <FeedGallery
                        feedList={creationList}
                        handleBinky={handleBinky}
                        handleComment={handleComment}
                        isCampRoom={true}
                      />
                    </InfiniteScroll>
                  </div>
                )}
              </Container>
            </div>
          )}
        </div>
        <MyRoomRightSideBar
          width={width}
          isKidsRoom={true}
          setRightCollapsse={setRightCollapsse}
          isNewChallengesButton={true}
          selectedTabClass={selectedTabClass}
          leftCollapsse={leftCollapsse}
        />
      </div>
    </div>
  );
};

export default TeachersRoom;
